import React, { useState, useEffect,useContext } from 'react';
import {
  CircularProgress,
  Container,
  Typography,
  Checkbox,
  FormControlLabel,
  Button,
  Alert
} from '@mui/material';
import userApi from '../../api/userApi';
import consensoApi from '../../api/consensoApi';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../auth/AuthContext';

export default function ConsensoPage() {
  const { logout } = useContext(AuthContext);
  const [checked, setChecked] = useState(false);
  const [err, setErr] = useState(null);
  const [consenso, setConsenso] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const { user, setUser } = useContext(AuthContext);
    useEffect(() => {
      const fetchConsenso = async () => {
        try {
          const res = await consensoApi.getconsenso(); // esempio endpoint
          console.log("consenso",res.data);
          setConsenso(res.data);
        } catch (err) {
          console.error(err);
        } finally {
           setLoading(false);
        }
      };
      fetchConsenso();
    }, []);
    if(loading) return <CircularProgress />;
  console.log("consenso",consenso);
  const refreshUser = async () => {
    const res = await userApi.me(); // /me
    console.log("ConsensoPage res",res);
    setUser({
                username: res.username,
                nomecognomeutente: res.nomecognomeutente,
                role: res.profilo,
                studioId: res.studioId,
                codiceInvito: res.codiceInvito,
                contribuenteId: res.contribuenteId,
                userId: res.id,
                enabled: res.enabled,
                tipoContratto: res.tipoContratto,
                statoContratto: res.statoContratto,
                contrattoAttivo: res.contrattoAttivo,
                giorniResidui: res.giorniResidui,
                contrattoId: res.contrattoId,
                googleCalendarEnabled: res.googleCalendarEnabled,
                stripeenabled: res.stripeenabled,
                calendarEnabled: res.calendarEnabled,
                    });
        console.log("ConsensoPage user",user);
        localStorage.setItem("user", JSON.stringify(user));
      if (user.role === 'STUDIO') {
        navigate(`/dashboard/studio/${user.studioId}`);
      } else if (user.role === 'CONTRIBUENTE') {
        navigate(`/dashboard/contribuente/${user.contribuenteId}`);
      } else {
        navigate('/dashboard');
      }
  };
  const handleLogout = () => {
    logout();
    navigate('/login');
  };
  const submit = async (e) => {
    e.preventDefault();

    if (!checked) {
      setErr("Devi accettare l'informativa per continuare");
      return;
    }

    try {
      await userApi.accettaConsenso();

      await handleLogout();


    } catch (e) {
      setErr(e.response?.data || e.message);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>
        Informativa Privacy & Consenso
      </Typography>

      <Typography variant="body2" sx={{ mb: 2 }}>
        Per poter utilizzare l’applicazione è necessario leggere e accettare
        label seguente informativa sul trattamento dei dati personali.
      </Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
          {consenso.testo}
      </Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        Versione: {consenso.versione}
      </Typography>
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={e => setChecked(e.target.checked)}
          />
        }
        label="Dichiaro di aver letto e accettato l’informativa privacy (verrai rimandato alla pagina di login)"
      />

      {err && <Alert severity="error" sx={{ mt: 2 }}>{err}</Alert>}

      <Button
        variant="contained"
        fullWidth
        sx={{ mt: 3 }}
        onClick={submit}
      >
        Accetta e continua
      </Button>
    </Container>
  );
}